var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"header-action-btn",attrs:{"icon":"","color":"white"},on:{"click":_vm.onPressed}},'v-btn',_vm.attrs,false),_vm.listeners),[_vm._t("icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }